export default "__VITE_ASSET__BOZJ$NoG__"